/* ============================================================
   Departments and designations
   ------------------------------------------------------------
   One definition, shared by every screen that asks for them —
   Add Employee, the Manage Employees edit popup, and anything
   added later. Both are offered as suggestions rather than
   enforced, so titles that predate these lists still work.
   ============================================================ */

export const DEPARTMENTS = [
    "Engineering Service",
    "IT Department",
    "HR - Human Resource",
    "TA - Talent Acquisition",
    "Admin and Facilities",
    "Management",
];

/* The same ladder runs through each discipline, so the designation list is
   built from the two rather than typed out. Add a discipline or a level here
   and every screen picks it up. */
export const DISCIPLINES = ["Development", "QA", "DevOps"];

export const LEVELS = [
    "Associate",
    "Engineer",
    "Senior Engineer",
    "Team Lead",
    "Senior Team Lead",
    "Project Manager",
    "Senior Project Manager",
];

export const DESIGNATIONS = DISCIPLINES.flatMap((group) =>
    LEVELS.map((level) => ({ group, label: `${group} ${level}` })));

/* Autocomplete options are objects when grouped and plain strings otherwise,
   so both need unwrapping to the value that gets stored. */
export const optionLabel = (option) =>
    (typeof option === "string" ? option : option?.label || "");
